"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_paper_1 = require("react-native-paper");
const dayjs_1 = __importDefault(require("dayjs"));
const duration_1 = __importDefault(require("dayjs/plugin/duration"));
const styles_1 = __importDefault(require("../../../../../styles/styles"));
const Timer = ({ datetimeStarted }) => {
    dayjs_1.default.extend(duration_1.default);
    const [timeDisplay, setTimeDisplay] = react_1.useState('00:00:00');
    react_1.useEffect(() => {
        const interval = setInterval(() => {
            // date now
            const dateStartedObj = dayjs_1.default(datetimeStarted);
            const nowObj = dayjs_1.default();
            setTimeDisplay(dayjs_1.default.duration(nowObj.diff(dateStartedObj)).format('HH:mm:ss'));
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    return react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlack }, timeDisplay);
};
exports.default = Timer;
